__webpack_require__.p = "/palletbox.app/";